export * from './onclick'
